<template>
  <div>
    <iframe
      height="360px"
      width="380px"
      :src="this.adminLoginFrameUrl"
    ></iframe>
  </div>
</template>

<script>
import JwtUtilService from "@/services/jwt.util.service";
import Base64 from "crypto-js/enc-base64";
import sha256 from "crypto-js/sha256";
export default {
  name: "Login",
  data() {
    return {
      adminLoginFrameUrl: "",
    };
  },
  mounted() {
    const clientID = process.env.VUE_APP_KEYCLOAK_CLIENT_ID;
    JwtUtilService.removeToken("rekab");
    JwtUtilService.setClientID(clientID);

    JwtUtilService.removeCodeChallenge();
    JwtUtilService.removeCodeVerifier();
    JwtUtilService.removeIdToken();

    const code_verifier = this.generateRandomString();
    const code_challenge = encodeURI(Base64.stringify(sha256(code_verifier)))
      .replaceAll(/\+/g, "-")
      .replaceAll(/\//g, "_")
      .replaceAll(/=+$/g, "");

    JwtUtilService.setCodeVerifier(code_verifier);
    JwtUtilService.setCodeChallenge(code_challenge);

    this.adminLoginFrameUrl =
      process.env.VUE_APP_KEYCLOAK_URL +
      `/auth?client_id=${clientID}&redirect_uri=${window.location.origin}/callback&grant_type=authorization_code&response_type=code&scope=openid&code_challenge=${code_challenge}&code_challenge_method=S256`;
  },
  methods: {
    generateRandomString() {
      let characters = "abcdefghijklmnopqrstuvwxyz0123456789";
      let result = "";
      let charactersLength = characters.length;

      for (let i = 0; i < 44; i++) {
        result += characters.charAt(
          Math.floor(Math.random() * charactersLength)
        );
      }

      return result;
    },
  },
};
</script>